import { render, staticRenderFns } from "./PeopleIndex.vue?vue&type=template&id=62a0a63e&"
import script from "./PeopleIndex.vue?vue&type=script&lang=js&"
export * from "./PeopleIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports